// @flow
import React from 'react'
import styled from 'styled-components'
import theme from 'styled-theming'

import { myTheme } from '../../styles'

// Styles
// ----------------------------------------

const {
  color, space, borderRadii, breakpoint,
} = myTheme

const mixBlendMode = theme('mode', {
  light: 'darken',
  dark: 'lighten',
})

// Container
// ----------------------------------------

const SVGWrap = styled.div`
  padding: ${space.half};
  background-color: transparent;
  border-radius: ${borderRadii.three};
  transition-property: background-color, transform;
  transition-duration: 150ms;
  transition-timing-function: ease-in;

  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }

  @media screen and (min-width: ${breakpoint.medium}) {
    &:hover [data-line-identifier='yShape'] {
      transform: rotate(178deg);
    }
    &:hover [data-line-identifier='xShape'] {
      transform: rotate(142deg);
    }
  }
`

const SVG = styled.svg`
  position: relative;
  top: 2px;
`

// This is the individual lines from the logo. (extend)
const ShapeContainer = styled.g`
  transform-origin: center center;
  transition: transform 250ms ease-in-out;
`

// Shape
// ----------------------------------------

const Line = styled.rect`
  mix-blend-mode: ${mixBlendMode};
`
const XContainer = ShapeContainer.extend`
  transform: rotate(150deg);
`
const YContainer = ShapeContainer.extend`
  transform: rotate(170deg);
`

type Props = {
  className?: string,
  xShapeFill?: string,
  yShapeFill?: string,
}

const Logo = ({ className, xShapeFill, yShapeFill }: Props) => (
  <SVGWrap className={className}>
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <XContainer data-line-identifier="xShape">
          <Line
            width="42"
            height="3"
            y="19.5"
            fill={xShapeFill}
            rx="1.5"
          />
        </XContainer>
        <YContainer data-line-identifier="yShape">
          <Line
            width="3"
            height="42"
            x="19.5"
            fill={yShapeFill}
            rx="1.5"
          />
        </YContainer>
      </g>
    </SVG>
  </SVGWrap>
)
Logo.defaultProps = {
  className: '',
  xShapeFill: color.strongPurple,
  yShapeFill: color.cyan,
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/logo/index.js